import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "palmeira",
        nomePrefeitura: "Prefeitura Municipal de Palmeira",
        logo: "palmeira/logos/brasao.png",
        brasao: "palmeira/logos/brasao.png",
        municipio: "| PALMEIRA - PR",
    },
    webgeo: {
        allowMapDragAtAnyZoom: true,
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        confrontante: {
            informacoesRodape:
                "Departamento de Arrecadação Imobiliária Rua Luiza Trombini Malucelli, 134 – Centro Cívico – Palmeira PR 42-3909-5088",
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        consultaPrevia: {
            nomeSecretaria: "Secretaria Municipal de Urbanismo",
            contact: {
                email: "xxx",
                endereco: "xxx",
                horarioAtendimento: "xxx",
                telefone: "xxx",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: true,
            consultaPrevia: true,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-49.994832, -25.424493],
            zoom: 18,
        },
    },
    api: {
        url: process.env.REACT_APP_MIGRATION
            ? "https://webgeo-migration.semv.com.br/api/palmeira"
            : "https://api-prd.semv.com.br/palmeira/",
    },
    geoserver: {
        url: process.env.REACT_APP_MIGRATION
            ? "https://geoserver-migration.semv.com.br/geoserver"
            : "https://geoserver-migration.semv.com.br/geoserver",
        ortoUrl: "https://geoserver-orto.semv.com.br/geoserver",
    },
} as IEnv;
